import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { logout } from "../../store/slices/auth";
import { useTranslation } from "react-i18next";
import AppConfig, { SYSTEM_ROLE } from "config/AppConfig";
import Notification from "./Notification";
import StorageHelper from "../../utilities/StorageHelper";
import { IconButton } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const Styles = {
  ...styles,
  navItem: {
    margin: "0 0.5rem",
  },
  wrapItems: {
    display: "flex",
    alignItems: "center",
  },
  iconButton: {
    padding: "0 12px",
  },
};
const useStyles = makeStyles(Styles);

const UserNavbarLinks = (props) => {
  const { userInfo } = props;
  const user = StorageHelper.getLocalObject(AppConfig.STORAGE_KEYS.user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const showNotifications =
    user?.role === SYSTEM_ROLE.HOSPITAL_ADMIN ||
    user?.role === SYSTEM_ROLE.HOSPITAL_OTHER ||
    user?.role === SYSTEM_ROLE.COORDINATOR_ADMIN ||
    user?.role === SYSTEM_ROLE.COORDINATOR_OTHER ||
    user?.role === SYSTEM_ROLE.PARTICIPANT;
  const signOut = async () => {
    const clone = { ...userInfo };
    const { role } = clone;
    await dispatch(logout());
    switch (role) {
      case SYSTEM_ROLE.SUPER_ADMIN:
      case SYSTEM_ROLE.MANAGER:
        history.push("/auth/login");
        break;
      case SYSTEM_ROLE.HOSPITAL_ADMIN:
      case SYSTEM_ROLE.HOSPITAL_OTHER:
      case SYSTEM_ROLE.COORDINATOR_ADMIN:
      case SYSTEM_ROLE.COORDINATOR_OTHER:
      case SYSTEM_ROLE.PARTICIPANT:
        history.push("/auth/client/login");
        break;
      case SYSTEM_ROLE.NURSE:
      case SYSTEM_ROLE.SUPPORT_WORKER:
        history.push("/auth/worker/login");
        break;
      case SYSTEM_ROLE.COMPANY:
        history.push("/auth/company/login");
        break;
      default:
        break;
    }
  };
  return (
    <div>
      <div className={classes.wrapItems}>
        {showNotifications && <Notification />}
        <IconButton
          onClick={() => signOut()}
          aria-label={`${t("button.logout")}`}
          aria-controls="long-menu"
          className={classes.iconButton}
        >
          <ExitToAppIcon />
        </IconButton>
      </div>
    </div>
  );
};

UserNavbarLinks.propTypes = {
  userInfo: PropTypes.object,
};

export default UserNavbarLinks;
